import i18n from "@/shared/i18n";
import InvoiceModel from "@/modules/invoices/models/Invoice.model";
import CustomerService from "@/modules/customer/CustomerService";
import BranchService from "@/modules/setup/branch/BranchService";
import InvoiceService from "@/modules/invoices/InvoicesService";
import moment from 'moment';
import SalesService from "@/modules/sales/SalesService";

let paymentLabels = {
  'payment': i18n.t('Type'),
  'amount': i18n.t('Amount'),
  'invoice': i18n.t('Invoice')
}
export const invoiceLabels = {
  ...new InvoiceModel().attributeLabels,
  'total_amount': i18n.t('Total Amount'),
  'miscellaneous_vat': i18n.t('Miscellaneous VAT'),
  'miscellaneous_charge': i18n.t('Miscellaneous Charges'),
  'premium_vat': i18n.t('Premium VAT'),
  'paid_amount': i18n.t('Total Paid Amount'),
  'premium': i18n.t('Premium'),
  'extra_charge_data': i18n.t('Extra Charge Data'),
  'deposit_amount': i18n.t('Deposit Amount'),
  'hammer_vat': i18n.t('Hammer VAT'),
  'hammer_price': i18n.t('Hammer Price'),
  'extra_charge': i18n.t('Extra Charge'),
  'extra_charge_vat': i18n.t('Extra Charge VAT'),
  'import_tax': i18n.t('Import Tax'),
  'shipping_vat': i18n.t('Shipping VAT'),
  'shipping_status': i18n.t('Shipping Status'),
  'shipping_amount': i18n.t('Shipping Amount'),
  'is_dispatched': i18n.t('Dispatched'),
  'complaint_status': i18n.t('Complaint Status')
}
export const notificationLabels = {
  'data': i18n.t('Data'),
  'type': i18n.t('Type'),
  'total': i18n.t('Total'),
  'status': i18n.t('Status'),
  'successful': i18n.t('Successful'),
  'failed': i18n.t('Failed')
}
const invoicesActivityHelper = {
  actions: {
    'create.invoice': {
      message: i18n.t('Invoice was created'),
      attributeLabels: invoiceLabels,
      excludeAttributes: ['bidder', 'currency', 'auction_house']
    },
    'update.invoice': {
      message: i18n.t('Invoice was updated'),
      attributeLabels: invoiceLabels,
      excludeAttributes: ['unpaid_notification_send_at', 'unpaid_notification_send_by', 'overdue_notification_send_at', 'overdue_notification_send_by']
    },
    'cancelled.invoice': {
      message: i18n.t('Invoice was cancelled'),
    },
    'credited.invoice': {
      message: i18n.t('Credit note was created'),
    },
    'unpaid.invoice': {
      message: i18n.t('Invoice status changed to unpaid'),
    },
    'create.invoice_payment': {
      message: i18n.t('Payment was created'),
      attributeLabels: paymentLabels,
      excludeAttributes: []
    },
    'update.invoice_payment': {
      message: i18n.t('Payment was updated'),
      attributeLabels: paymentLabels,
      excludeAttributes: []
    },
    'delete.invoice_payment': {
      message: i18n.t('Payment was deleted'),
    },
    'unpaid_invoice_notification': {
      message: i18n.t('Unpaid notification was sent'),
      attributeLabels: notificationLabels,
      excludeAttributes: ['action']
    },
    'overdue_invoice_notification': {
      message: i18n.t('Overdue notification was sent'),
      attributeLabels: notificationLabels,
      excludeAttributes: ['action']
    },
    'credit_note_notification': {
      message: i18n.t('Credit note notification was sent'),
      attributeLabels: notificationLabels,
      excludeAttributes: ['action']
    },
    'update.invoice_miscellaneous_items': {
      message: i18n.t('Miscellaneous items were updated'),
    },
    'unmark_collected': {
      message: i18n.t('Invoice was unmarked collected'),
    },
    'mark_collected': {
      message: i18n.t('Invoice was marked collected'),
    },
    'signed_by_staff': {
      message: i18n.t('Collection note was signed by staff'),
      attributeLabels: notificationLabels,
      excludeAttributes: ['action']
    },
    'signed_by_buyer': {
      message: i18n.t('Collection note was signed by buyer'),
      attributeLabels: notificationLabels,
      excludeAttributes: ['action']
    },
    'collection_note_created': {
      message: i18n.t('Collection note was created'),
      attributeLabels: {
        description: i18n.t('Description'),
        is_collected_by_third_party: i18n.t('Collected by 3rd Party'),
        collector: i18n.t('Collector'),
        collector_note: i18n.t('Note'),
        inventories: i18n.t('Inventory Items'),
      },
      excludeAttributes: ['action']
    },
    'collection_note_regenerated': {
      message: i18n.t('Collection note was regenerated'),
      attributeLabels: {
        description: i18n.t('Description'),
        is_collected_by_third_party: i18n.t('Collected by 3rd Party'),
        collector: i18n.t('Collector'),
        collector_note: i18n.t('Note'),
        inventories: i18n.t('Inventory Items'),
      },
      excludeAttributes: ['action']
    },
  },

  async valueVisualizer(activity, attr, val) {
    let returnValue = val;
    if (activity.name === 'invoice') {
      if (attr === 'branch') {
        let response = await BranchService.getBranch(val);
        returnValue = response.body.name;
      } else if (attr === 'customer') {
        let response = await CustomerService.getCustomer(val);
        returnValue = response.body.display_name;
      } else if (attr === 'auction') {
        let response = await SalesService.getSale(val);
        returnValue = response.body.sale_no;
      } else if (attr === 'complaint_status') {
        if (!val) {
          returnValue = "N/A";
        }
      }
    }
    if (activity.name === 'mailing') {
      if (attr === 'data') {
        returnValue = {}
        returnValue[i18n.t("Invoice")] = val.invoice_no;
        returnValue[i18n.t("Customer")] = val.customer_display_name;
        returnValue[i18n.t("Customer email")] = val.to_email;
        returnValue[i18n.t("Invoice type")] = val.invoice_type;
        returnValue[i18n.t("Success")] = val.success ? i18n.t("Yes") : i18n.t("No");
        returnValue[i18n.t("Sent at")] = moment(val.sent_at).format('DD-MM-YYYY');
      }
    }
    if (activity.name === 'invoice_payment') {
      if (attr === 'invoice') {
        let response = await InvoiceService.getInvoice(val);
        returnValue = response.body.invoice_no;
      } else if (attr === 'payment') {
        let response = await InvoiceService.getPayment(val);
        returnValue = response.body.type ? response.body.type : 'N/A';
      }
    }
    return returnValue;
  }
}

export default invoicesActivityHelper;
